import { UserRole } from 'app-types/core';

export const enum EnumDeskRoutes {
  settings = 'settings',
  workspaceSetup = 'workspace-setup',
  workspaceSetupComplete = 'workspace-setup-complete',
  newTicket = 'new-ticket',
  newCourierTicket = 'new-courier-ticket',
  newCustomerTicket = 'new-customer-ticket',
  desk = 'desk',
}

export const enum EnumSettingRoutes {
  myProfile = 'my-profile',
  configuration = 'configuration',
  courierSetting = 'courier-settings',
  agents = 'agents',
  teams = 'teams',
  routingRules = 'routing-rules',
  tags = 'tags',
  templateLibrary = 'template-library',
  companyFolders = 'company-folders',
  personalFolders = 'personal-folders',
  importData = 'import-data',
  voiceCall = 'voice-call',
  rating = 'rating-page',
  tracking = 'tracking',
  branding = 'branding',
  returnsAndExchanges = 'returns-and-exchanges',
  notifications = 'notifications',
  advancedTools = 'advanced-tools',
  aiSettings = 'ai-settings',
}

export const enum EnumGeneralSettingRoutes {
  general = 'general',
  integrations = 'integrations',
  userSettings = 'user-settings',
  userManagement = 'user-management',
  integration = 'integration',
  billing = 'billing',
  subscription = 'subscription',
  publicApi = 'public-api',
  thirdPartyIntegrations = 'third-party-integrations',
  rolesAndPermissions = 'roles-and-permissions',
}

export const enum EnumFulfillmentSettingRoutes {
  fulfillment = 'fulfillment',
  pickingAndPacking = 'picking-and-packing',
}

export const enum EnumAdvancedToolsRoutes {
  cashOnDelivery = 'cash-on-delivery',
  ordersExport = 'orders-export',
}

export const enum EnumShippingSettingRoutes {
  shipping = 'shipping',
  shippingConfiguration = 'shipping-configuration',
  shippingRules = 'shipping-rules',
  shippingCouriers = 'shipping-couriers',
}

export const enum EnumShippingConfigurationRoutes {
  warehouses = 'warehouses',
  packageSizes = 'package-sizes',
  printingSettings = 'printing-settings',
  measureSystem = 'measure-system',
  trackingMode = 'tracking-mode',
}

export const enum EnumShippingCourierIntegrationsRoutes {
  authorizedMerchants = 'authorized-merchants',
  shippingMethods = 'shipping-methods',
  settings = 'settings',
  assignedWarehouses = 'assigned-warehouses',
  surcharges = 'surcharges',
  webserviceCredentials = 'webservice-credentials',
}

export const enum EnumTrackingRoutes {
  tracking = 'tracking',
  portalStyle = 'portal-style',
  banner = 'banner',
  smartActions = 'smart-actions',
  translations = 'translations',
  created = 'created',
  inTransit = 'in-transit',
  incidents = 'incidents',
  delivered = 'delivered',
  views = 'views',
  view = 'view',
}

export const enum EnumReturnsAndExchangesRoutes {
  returnRules = 'rules',
  returnReasons = 'reasons',
  returnInstructions = 'instructions',
  returnTranslations = 'translations',
}

export const enum EnumNotificationsRoutes {
  configuration = 'configuration',
  touchPoints = 'touch-points',
  reviewBooster = 'review-booster',
  hyperNotifications = 'hyper-notifications',
}

export const enum EnumTrackingTranslationsRoutes {
  tracking = 'tracking',
  loginPage = 'login-page',
  orderStatus = 'order-status',
  suggestedProducts = 'suggested-products',
  questionsAndAnswers = 'questions-and-answers',
  rateOrder = 'rate-order',
  cancelOrder = 'cancel-order',
  editDeliveryInfo = 'edit-delivery-info',
}

export const enum EnumReturnsAndExchangesTranslationsRoutes {
  loginPage = 'login-page',
  orderList = 'order-list',
  reasonSelection = 'reason-selection',
  exchangeForAnotherVariant = 'exchange-for-another-variant',
  exchangeForAnotherProduct = 'exchange-for-another-product',
  methodSelection = 'method-selection',
  summary = 'summary',
  confirmation = 'confirmation',
  links = 'links',
  questionsAndAnswers = 'questions-and-answers',
}

export const enum QueryParams {
  DuplicateId = 'duplicateId',
}

export const enum EnumChatSettingRoutes {
  chatStyle = 'chat-style',
  chatContent = 'chat-content',
  chatInstallation = 'chat-installation',
  chatAvailability = 'chat-availability',
  automation = 'automation',
}

export const enum EnumAiSettingRoutes {
  brandKnowledgeFiles = 'brand-knowledge-files',
}

export const enum EnumWelcomeRoutes {
  welcome = 'welcome',
  contactInfo = 'contact-info',
  howDidYouFindUs = 'how-did-you-find-us',
  howCanWeHelp = 'how-can-we-help',
  storeSize = 'store-size',
  selectCms = 'select-cms',
  shopIntegration = 'integration',
  install = 'install',
  login = 'login',
  apiConnect = 'api-connect',
  onlineStoreUrl = 'online-store-url',
  onlineStoreEmail = 'online-store-email',
  allDone = 'all-done',
  accountReview = 'account-review',
}

export const enum OrdersTabRoutes {
  orderList = 'order-list',
  created = 'created',
  packing = 'packing',
  picking = 'picking',
  orders = 'orders',
  pickingList = 'picking-list',
  packingList = 'packing-list',
  courierPickups = 'courier-pickups',
  courierHealth = 'courier-health',
  shipped = 'shipped',
  shippingDocuments = 'shipping-documents',
  preview = 'preview',
  view = 'view',
  views = 'views',
}

export const enum AnalyticsTabRoutes {
  analytics = 'analytics',
  overview = 'overview',
  sales = 'sales',
  shipping = 'shipping',
  returns = 'returns',
  revenuePlus = 'revenue-plus',
  picking = 'picking',
  notifications = 'notifications',
  desk = 'desk',
  details = 'details',
  topCustomers = 'top-customers',
  topProducts = 'top-products',
  ordersPerCountry = 'orders-per-country',
  incidentsByType = 'incidents-by-type',
  topReturnedProducts = 'top-returned-products',
  topReturnReasons = 'top-return-reasons',
}

export const enum ReturnsTabRoutes {
  returns = 'returns',
  all = 'all',
  returnList = 'return-list',
  exchangeList = 'exchange-list',
  completed = 'completed',
}

export const enum InvoiceCheckingTabRoutes {
  invoice = 'invoice',
  checking = 'checking',
  settings = 'settings',
  uploadInvoice = 'upload-invoice',
}

export const enum GeneralRoutes {
  dashboard = 'dashboard',
  desk = 'desk',
  manageBrands = 'manage-brands',
  thirdParty = 'third-party',
  emails = 'emails',
  sent = 'sent',
}

export const enum UserSupportRoutes {
  userSupport = 'user-support',
  ticket = 'ticket',
  support = 'support',
}

const adminRoles = [UserRole.Owner, UserRole.Administrator, UserRole.Manager];

export const RoutesAccess = {
  [GeneralRoutes.dashboard]: {
    roles: adminRoles,
  },
  [GeneralRoutes.desk]: {
    roles: [...adminRoles, UserRole.CustomerSupport],
  },
  [GeneralRoutes.manageBrands]: {
    roles: adminRoles,
  },
  [EnumGeneralSettingRoutes.general]: {
    roles: adminRoles,
  },
  [EnumSettingRoutes.branding]: {
    roles: adminRoles,
  },
  [EnumFulfillmentSettingRoutes.fulfillment]: {
    roles: adminRoles,
  },
  [EnumShippingSettingRoutes.shipping]: {
    roles: adminRoles,
  },
  [EnumSettingRoutes.tracking]: {
    roles: adminRoles,
  },
  [EnumSettingRoutes.notifications]: {
    roles: adminRoles,
  },
  [EnumSettingRoutes.returnsAndExchanges]: {
    roles: adminRoles,
  },
};
